import React from 'react';
import { Form } from 'formik';

import type { GetInputOptionsAndLabelFunc, GetSelectOrAutocompleteDisplayValueFunc } from 'app/components';
import DetailsPanel from 'app/components/DetailsPanel';
import type { UseQueryRefetch } from 'app/types';
import type { EmployeeDetailsPanelFormValues } from 'app/Domain/Employees/Pages/EmployeeDetailPage/components/EmployeeInfoTab/components/EmployeeDetailsPanel/EmployeeDetailsPanel.types';

import {
  EmployeeDetailsPanelActions,
  EmployeeDetailsPanelConfirmationDialog,
  EmployeeDetailsPanelHeader,
} from './EmployeeDetailsPanelFormControls';

type EmployeeDetailsPanelFormViewProps = {
  submitConfirmationDialogState: boolean;
  closeSubmitConfirmationDialog: () => void;
  submitFormAfterConfirmation: () => void;
  initialValues: EmployeeDetailsPanelFormValues;
  values: EmployeeDetailsPanelFormValues;
  getSelectOrAutocompleteDisplayValue: GetSelectOrAutocompleteDisplayValueFunc;
  getInputOptionsAndLabel: GetInputOptionsAndLabelFunc;
  loading: boolean;
  synchronizationStatus: boolean | undefined;
  refetchGetEmployeeSynchronizationQuery: UseQueryRefetch;
  disabledActionButtonsWhileLoading: boolean;
  employeeId: string | undefined;
  connectionId: string | undefined;
  deletedBySourceAddress?: boolean;
  deletedBySourcePersonal?: boolean;
  employeeDetails: any[];
  isEdit: boolean;
  onClickEditButton: () => void;
  onClickCancelButton: () => void;
  onClickSubmit: () => void;
  disabledIfNoAccessToEmployeeEdit: boolean;
  disabledIfNoAccessToConnectionRun: boolean;
};

export const EmployeeDetailsPanelFormView = ({
  submitConfirmationDialogState,
  closeSubmitConfirmationDialog,
  submitFormAfterConfirmation,
  initialValues,
  values,
  getSelectOrAutocompleteDisplayValue,
  getInputOptionsAndLabel,
  loading,
  synchronizationStatus,
  refetchGetEmployeeSynchronizationQuery,
  disabledActionButtonsWhileLoading,
  employeeId,
  connectionId,
  deletedBySourceAddress,
  deletedBySourcePersonal,
  employeeDetails,
  isEdit,
  onClickEditButton,
  onClickCancelButton,
  onClickSubmit,
  disabledIfNoAccessToEmployeeEdit,
  disabledIfNoAccessToConnectionRun,
}: EmployeeDetailsPanelFormViewProps) => (
  <>
    {submitConfirmationDialogState && (
      <EmployeeDetailsPanelConfirmationDialog
        open={submitConfirmationDialogState}
        onClose={closeSubmitConfirmationDialog}
        onConfirm={submitFormAfterConfirmation}
        previousValues={initialValues}
        newValues={values}
        getSelectOrAutocompleteDisplayValue={getSelectOrAutocompleteDisplayValue}
        getInputOptionsAndLabel={getInputOptionsAndLabel}
      />
    )}
    <Form>
      <DetailsPanel
        header={
          <EmployeeDetailsPanelHeader
            loading={loading}
            synchronizationStatus={synchronizationStatus}
            refetchGetEmployeeSynchronizationQuery={refetchGetEmployeeSynchronizationQuery}
            disabledActionButtonsWhileLoading={disabledActionButtonsWhileLoading}
            employeeId={employeeId}
            connectionId={connectionId}
            deletedBySourceAddress={deletedBySourceAddress}
            deletedBySourcePersonal={deletedBySourcePersonal}
          />
        }
        columnsContainerSx={{ minHeight: '46em' }}
        columns={employeeDetails}
        loading={loading}
        actions={
          <EmployeeDetailsPanelActions
            isEdit={isEdit}
            onClickEditButton={onClickEditButton}
            onClickCancelButton={onClickCancelButton}
            onClickSubmit={onClickSubmit}
            disabledActionButtonsWhileLoading={disabledActionButtonsWhileLoading}
            synchronizationStatus={synchronizationStatus}
            disabledIfNoAccessToEmployeeEdit={disabledIfNoAccessToEmployeeEdit}
            disabledIfNoAccessToConnectionRun={disabledIfNoAccessToConnectionRun}
          />
        }
      />
    </Form>
  </>
);
